<template>

  <footer class="footer p-10 text-base-content">
    <div class="flex flex-col">
      <NuxtLink to="/" class="logo-dark hidden">
        <img src="@/assets/img/supapm-logo-dark.svg" alt="Logo" width="80" height="33">
      </NuxtLink>
      <NuxtLink to="/" class="logo-light hidden">
        <img src="@/assets/img/supapm-logo.svg" alt="Logo" width="80" height="33">
      </NuxtLink>
      <div>
        
        <div
          class="tooltip tooltip-right"
          :data-tip="`Platform build ${metadata.build}`"
        >
          <p class="muted text-xs" tabindex="0" :aria-label="platformVersionLabel">
            Platform v{{ metadata.buildMajor }}.{{ metadata.buildMinor }}.{{ metadata.buildRevision }}
          </p>
        </div>
        <p class="muted text-xs mt-1" tabindex="0" :aria-label="extensionVersionLabel">
          Extension v{{ metadata.extensionVersion }}
        </p>
      </div>
      <label class="swap swap-rotate mt-1">

        <!-- this hidden checkbox controls the state -->
        <input type="checkbox" v-model="colorScheme" true-value="myDark" false-value="myLight" />

        <!-- sun icon -->
        <svg class="swap-on" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="5" />
          <path
            d="M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" />
        </svg>

        <!-- moon icon -->
        <svg class="swap-off" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>

      </label>
    </div>
    <div class="linkCols">
      <span class="footer-title">Product</span>
      <NuxtLink to="/updates" class="">
        Updates
      </NuxtLink>
      <!-- <NuxtLink to="/api" class="">
        API
      </NuxtLink>
      <NuxtLink to="/faq" class="">
        FAQ
      </NuxtLink> -->
      <!-- <NuxtLink
        to="/blog"
        class=""
      >
        Blog
      </NuxtLink>
      <NuxtLink
        to="/contact"
        class=""
      >
        Contact
      </NuxtLink>
      <NuxtLink
        to="/affiliate"
        class=""
      >
        Affiliate program
      </NuxtLink> -->
    </div>
    <div class="linkCols">
      <span class="footer-title">Legal</span>
      <NuxtLink to="/terms" class="">
        Terms of use
      </NuxtLink>
      <NuxtLink to="/privacy-policy" class="">
        Privacy policy
      </NuxtLink>
      <NuxtLink to="/cookie-policy" class="">
        Cookie policy
      </NuxtLink>
      <NuxtLink to="/security" class="">
        Security
      </NuxtLink>
    </div>
  </footer>

</template>

<style scoped>

footer {
  max-width: 1600px;
  margin:auto;
}

footer .linkCols {
  gap: 0px;
  width: 100%;
}

footer .linkCols a {
  min-height: 48px;
  min-width: 48px;
  padding-block: 14px;
  width: 100%;
  display: flex;
  align-items: center;
}
    
</style>

<script setup>

import metadata from '../appVersion.json'
const colorScheme = useColorScheme()
const supabaseUserData = useSupabaseUserData()
const platformVersionLabel = `Platform version ${metadata.buildMajor}.${metadata.buildMinor}.${metadata.buildRevision}`
const extensionVersionLabel = `Extension version ${metadata.extensionVersion}`

watch(colorScheme, (newColorScheme) => {
  console.log("colorScheme changed:", newColorScheme)
  if (supabaseUserData.value && supabaseUserData.value.personal_settings) {
    supabaseUserData.value.personal_settings.theme = newColorScheme
  }
})

const computedThemeColor = computed(() => {
  return colorScheme.value === 'myDark' ? 'myDark' : 'myLight';
});

useHead({
  htmlAttrs: {
    'data-theme': colorScheme
  },
  meta: [
    {
      name: 'theme-color',
      content: computedThemeColor,
    }
  ]
}, {
  mode: 'client'
})
</script>